import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RecaptchaBadgeVisibility = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/app" || pathname.startsWith("/app/")) {
      document.documentElement.dataset.recaptchaBadgeHidden = "true";
    } else {
      delete document.documentElement.dataset.recaptchaBadgeHidden;
    }

    return () => {
      delete document.documentElement.dataset.recaptchaBadgeHidden;
    };
  }, [pathname]);

  return null;
};

export default RecaptchaBadgeVisibility;
